const getState = (state) => {
  return {
    ...state,
    height: window?.innerHeight,
    width: window?.innerWidth,
    mobile: window.innerWidth <= 767,
    ipad: window.innerWidth <= 991,
  };
};

const initialState = getState();

export default (state = initialState, action) => {
  switch (action.type) {
    case '@window/resize':
      return getState(state);

    default:
      return state;
  }
};
